import { Delay } from "components/atoms/Delay";
import { fortuneTellerIcon } from "components/templates/無料占いBot";
import dayjs from "dayjs";
import { Balloon } from "features/無料占いBot/components/Balloon";
import { Confirmable } from "features/無料占いBot/components/Confirmable";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { DateSelect } from "shared/components/molecules/DateSelect";
import { eventName, eventAction, useGaEvent } from "shared/hooks/useGaEvent";
import tw from "twin.macro";

const fieldName = "partnerBirthday";

const skipedStyle = tw`bg-gradient-twilight-to-r text-white`;

export const SelectPartnerBirthday = () => {
  const [skip, setSkip] = useState(false);

  const { register, watch } = useFormContext();
  const { sendEvent } = useGaEvent();

  const field = register(fieldName);
  const [value, themeId, answerId] = watch([fieldName, "theme", "answer"]);
  const date = dayjs(value).format("YYYY年MM月DD日");

  const handleClick = () => setSkip(true);

  const onClickConfirm = () => {
    sendEvent({
      eventName: eventName.freeFortuneChatBot,
      eventAction: eventAction.freeFortuneChatBot.confirmPartnerBirthDay,
      eventParams: {
        theme_id: themeId,
        answer_id: answerId,
      },
    });
  };

  return (
    <Confirmable
      name={fieldName}
      icon={fortuneTellerIcon}
      confirm={skip}
      text={`お相手の生年月日は${
        skip ? "「分からない」" : date
      }でお間違いありませんか？`}
      onClickConfirm={onClickConfirm}
    >
      <Delay icon={fortuneTellerIcon}>
        <Balloon icon={fortuneTellerIcon}>
          {`ありがとうございます😌\nでは次に【お相手の方の生年月日】を教えてください。\n\n⚠️お相手のいないお悩みの場合は、分からないをご選択ください🙇‍♀️\n`}
        </Balloon>
        <div tw="flex-col mb-4 flex items-end">
          <div tw="mb-4 w-auto">
            <DateSelect {...field} />
          </div>
          <button
            type="button"
            tw="border-card"
            css={skip && skipedStyle}
            onClick={handleClick}
          >
            分からない
          </button>
        </div>
      </Delay>
    </Confirmable>
  );
};
